/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import RateVariationCommission from './RateVariationCommission'
// import RatePercentage from './RatePercentage'
import RateVariationExcess from './RateVariationExcess'
// import VariationOptions from './VariationOptions'
import OptionsCheckbox from '../../Step05/components/OptionsCheckbox'
import BindContainer from '../../Step05/containers/BindContainer'
import IssueContainer from '../../Step05/containers/IssueContainer'
import PopUp from '../../../../common/PopUp/PopUp'
import { SpinnerIcon } from '../../../../../images/icons/Spinner/Spinner'

export default class RateVariation extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            commission: this.props.values.commission,
            TypeCommission: this.props.values.commission,
            excess: this.props.values.excess,
            optionsOpen: true,
            confirmRemove: false,
            confirmBind: false,
            dirtyVariationOption: false,
            viewIssuePopUp: false,
            btnCommison: false,
            confirmRate: false,
            requestBtn: true,
            values: this.props.values,
        }
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (nextProps !== this.props) {
            this.setState({
                commission: nextProps.values.commission,
                excess: nextProps.values.excess,
            })
        }
    }

    handlechange = ({ target: { value } }) => {
        this.setState(state => value <= 100.0 && { value } || state)
        // this.setState(state => value <= 22.5 && { value } || state)
        this.setState({
            TypeCommission: value,
            btnCommison: true,
            requestBtn: false,
        })
    }

    handleCheckbox = () => {
        return true
    }

    handleItemChange = (field: string, value: any) => {
        let obj = this.props.values
        obj.terrorism = value
        this.setState({
            btnCommison: true,
            requestBtn: false,
        })
        this.props.checkUpdate()
        this.props.updateQuoteVariation(this.props.quoteId, obj)
    }

    UpdateCommison = () => {
        let obj = this.props.values
        obj.experiencedRate = this.state.TypeCommission
        this.setState({
            btnCommison: false,
            requestBtn: false,
        })
        this.props.checkUpdate()
        this.props.updateQuoteVariation(this.props.quoteId, obj)
    }

    toggleOptionsOpen = () => this.setState({ optionsOpen: !this.state.optionsOpen })

    /**
     * Function to manage the change on Adjustments
     */
    handleAdjustChangecommission = (commission: any) => {

        let obj = this.props.values
        // console.log(obj)
        obj.commission = commission
        this.setState({
            requestBtn: false,
        })
        this.props.checkUpdate()
        this.props.updateQuoteVariation(this.props.quoteId, obj)

    }

    /**
     * Function to manage the change on Adjustments
     */
    handleAdjustChangeExcess = (excess) => {

        let obj = this.props.values

        // if(excess <= (this.props.totalCollection/2)){
        //     console.log(excess,this.props.values)
        //     obj.excess = excess
        // }
        if (excess < (this.props.totalCollection / 2)) {
            // console.log(excess, this.props.values)
            obj.excess = excess
        } else {
            obj.excess = 500
        }
        this.setState({
            requestBtn: false,
        })
        this.props.updateQuoteVariation(this.props.quoteId, obj)

    }

    /**
     * Function to manage the change on Options
     */
    handleAdjustChangeOptions = (obj: any) => {
        this.props.updateQuoteVariation(this.props.quoteId, obj)
    }

    /**
     * Function to manage Issue button action to trigger confirmation popup
     */
    // handleIssueButton = () => {
    //     if (this.props.editRenewal) {
    //         this.props.inviteQuoteVariation(this.props.quoteId)
    //         this.props.history.push('/renewals')
    //     } else {
    //         this.setState({ confirmIssue: true })
    //     }
    // }
    handleIssueRate = () => {
        // if (this.props.editRenewal) {
        //     this.props.inviteQuoteVariation(this.props.quoteId)
        //     this.props.history.push('/renewals')
        // } else {
        //     this.setState({ confirmIssue: true })
        // }
        this.setState({ confirmRate: true })
        this.handleClosePopup()
    }
    /**
     * Function to manage Bind Action
     */
    handleBind = () => {
        this.props.bindQuoteVariation(this.props.quoteId, this.props.values.id)
    }

    /**
     * Function to manage Bind Action
     */
    handleBindButton = () => {
        if (this.props.editRenewal) {
            this.props.renewalBindQuoteVariation(this.props.quoteId)
            this.props.history.push('/renewals')
        } else {
            this.setState({ confirmBind: true })
        }
    }

    triggerCheckSoftReferral = () => {
        this.props.checkSoftReferral(this.props.quoteId, this.props.values.id)
    }

    /**
     * Function to manage Remove Button
     */
    handleRemove = () => {
        this.props.delQuoteVariation(this.props.quoteId, this.props.values.id)
    }

    /**
     * Get one of the possible values passed
     * as props and decide the position of the range slider
     */
    handleExcess = (value: number) => {
        // console.log(value)
        switch (value) {
            case 500: return 0
            case 1000: return 1
            case 2500: return 2
            case 5000: return 3
            default: return 0
        }
    }

    disableRemoveButton = () => {
        if (this.props.editRenewal) {
            return false
        } else {
            return (this.props.values.isIssued || this.props.loading)
        }
    }
    okPopupRate = () => {
        this.setState({ confirmRate: false, confirmIssue: true })
    }

    cancelPopupRate = () => {
        this.setState({ confirmRate: false })
    }
    /**
     * Close all confirm popups
     */
    handleClosePopup = () => {
        this.setState({ confirmRemove: false, confirmBind: false, confirmIssue: false })

    }
    reqQuote = () => {
        this.setState({ confirmRemove: true })
        this.props.reqVariation()
    }

    render() {

        return (
            <div className="variation__block">

                {this.props.loading ? (
                    <div className="variation__loading">
                        <SpinnerIcon />
                    </div>
                ) : null}

                {(this.state.viewIssuePopUp) ?
                    <PopUp
                        title="Rate Requested"
                        action={() => {
                            window.location.href.includes('/clients/quotes/edit') ?
                                window.location.href = `/dashboard` :
                                this.setState({ viewIssuePopUp: false })

                        }}
                        buttonText="OK"

                    >
                        Thank you for requesting this quote; It has been referred to our underwriting team for approval
                    </PopUp>
                    : null}

                {this.state.confirmRemove ? (
                    <PopUp
                        title="Remove Rate Request"
                        buttonText="Remove"
                        action={this.handleRemove}
                        numberButtons={2}
                        secondaryButtonText="Cancel"
                        secondaryAction={this.handleClosePopup}
                    >
                        Please confirm removal of this Rate Request.
                    </PopUp>
                ) : null}

                {this.state.confirmRate ? (
                    < PopUp
                        title="Do you want to request this rate?"
                        buttonText="Request"
                        action={this.okPopupRate}
                        numberButtons={2}
                        secondaryButtonText="Cancel"
                        secondaryAction={this.cancelPopupRate}
                    >
                        Are you sure?
                    </ PopUp>
                ) : null}

                {this.state.confirmBind ? (
                    <BindContainer
                        handleClosePopup={this.handleClosePopup}
                        handleBind={this.handleBind}
                        quoteId={this.props.quoteId}
                        varId={this.props.values.id}
                        values={this.props.values}
                        commission={this.state.commission}
                        excess={this.state.excess}
                        isCollectors={false}
                        isMuseums={true}
                        isDealersStock={false}
                        isWineSpirits={false}
                        postIssuedQuotePopUp={() => { window.location.href = `/dashboard` }}
                    />
                ) : null}

                {this.state.confirmIssue ? (
                    <IssueContainer
                        handleClosePopup={this.handleClosePopup}
                        issuedQuotePopUp={() => this.setState({ viewIssuePopUp: true })}
                        postIssuedQuotePopUp={() => { window.location.href = `/dashboard` }}
                        quoteId={this.props.quoteId}
                        values={this.props.values}
                        varId={this.props.values.id}
                    />
                ) : null}

                <div className="variation__header">
                    <div className="variation__title">
                        <h4>Requested Quote</h4>
                    </div>
                    <div className="variation__result">
                        <div className="variation__result__text">Suggested Premium:</div>
                        <div className="variation__result__number">
                            £{this.props.values.premium}
                        </div>
                        <div className="variation__result__text">inc.IPT and Fee</div>
                    </div>
                </div>

                <div className="variation__adjustment">
                    <RateVariationCommission
                        onChange={this.handleAdjustChangecommission}
                        value={this.state.commission}
                    />
                </div>

                <div className="variation__adjustment">
                    <RateVariationExcess
                        onChange={this.handleAdjustChangeExcess}
                        value={this.state.excess}
                        totalCollection={this.props.totalCollection}
                    />
                </div>
                <div className="variation__adjustment">
                    {/* <RatePercentage
                        onChange={this.handleAdjusttypePercentage}
                        value={this.state.typeCommission}
                        totalCollection={this.props.totalCollection}
                    /> */}
                    <div className="adjustment">
                        <div className="adjustment__title req_rate_title">Please type in the box on the right the
                            percentage you would
                            like to apply:
                        </div>
                        {/* <div className="adjustment__result"> */}
                        <div className="req_rate_input">
                            <div className="my_percentage">%
                                <input
                                    type="number"
                                    name="value"
                                    placeholder="0"
                                    step="any"
                                    min={0}
                                    max={100.0}
                                    value={this.state.value}
                                    onChange={this.handlechange}
                                />
                            </div>
                        </div>
                    </div>
                    {/* 2.5%
                    </div> */}
                </div>

                <div className="variation__options">
                    {/* <VariationOptions
                        dirty={(dirtyVariationOption) => this.setState({ dirtyVariationOption })}
                        handleAdjustChangeOptions={this.handleAdjustChangeOptions}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.values}
                    /> */}
                    <div
                        className={`variation__options__content options`}
                    >
                        <OptionsCheckbox
                            id="terrorism"
                            title="Add terrorism cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.terrorism || false}
                            value={this.props.values.terrorism}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>

                    </div>
                </div>
                <button
                    className={`btnCommison ${this.state.btnCommison ? 'visible' : null}`}
                    type="submit"
                    onClick={this.UpdateCommison}
                >
                    Update
                </button>
                <div
                    className={`variation__actions
                        ${this.props.values.isIssued ? 'issued' : null}`}
                >

                    <button
                        className={`req_rate_button variation__actions__button
                        ${(this.disableRemoveButton()) ?
                                'issued' :
                                null}`
                        }
                        onClick={() => this.reqQuote()}
                        type="button"
                        disabled={this.disableRemoveButton()}
                    >
                        <span>{`${(this.props.editRenewal) ? 'Cancel' : 'Remove Quote'}`}</span>
                    </button>

                    <button
                        className={`req_rate_button variation__actions__button
                        ${(this.state.dirtyVariationOption || this.props.dirtySteps) &&
                                !this.props.editQuotes ? 'issued' : null}
                        ${(this.props.editQuotes && this.state.requestBtn) ? 'issued' : null}`}
                        // className={`variation__actions__button ${this.props.values.isIssued ? 'issued' : null}`}
                        onClick={this.handleIssueRate}
                        type="button"
                        disabled={(this.props.editQuotes) ?
                            this.state.requestBtn : this.state.dirtyVariationOption || this.props.dirtySteps}
                    // disabled={this.props.values.isIssued}
                    >
                        <span>{`${(this.props.editRenewal) ? 'Invite renewal' : 'Request quote'}`}</span>
                    </button>

                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05m/components/RateVariation.tsx